/**
 * Paleta de cores para o Avatar
 * Cores harmônicas e distintas para boa legibilidade
 */
const AVATAR_COLORS = [
  '#E53935', // Vermelho
  '#D81B60', // Rosa
  '#8E24AA', // Roxo
  '#5E35B1', // Roxo escuro
  '#3949AB', // Índigo
  '#1E88E5', // Azul
  '#00ACC1', // Ciano
  '#00897B', // Teal
  '#43A047', // Verde
  '#7CB342', // Verde claro
  '#F4511E', // Laranja escuro
  '#6D4C41', // Marrom
];

/**
 * Remove acentos de uma string
 */
function removeAccents(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Normaliza string: trim + lowercase + remove acentos
 * Garante consistência na geração de cores
 */
export function normalizeString(str: string): string {
  if (!str) return '';
  return removeAccents(str.trim().toLowerCase());
}

/**
 * Gera hash numérico simples de uma string
 * Usado para selecionar cor de forma determinística
 */
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

/**
 * Retorna uma cor da paleta baseada no nome
 * Mesma string sempre retorna mesma cor
 */
export function stringToColor(str: string): string {
  if (!str) return AVATAR_COLORS[0];
  const normalized = normalizeString(str);
  const hash = hashString(normalized);
  const index = hash % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
}

/**
 * Extrai iniciais de um nome (máximo 2 letras)
 * "João Silva" → "JS"
 * "Maria" → "MA"
 * "Ana Paula Costa" → "AC"
 */
export function getInitials(str: string): string {
  if (!str) return '??';

  const normalized = removeAccents(str.trim());
  const words = normalized.split(/\s+/).filter(w => w.length > 0);

  if (words.length === 0) return '??';

  if (words.length === 1) {
    // Nome único: pega as 2 primeiras letras
    return words[0].substring(0, 2).toUpperCase();
  }

  // Múltiplas palavras: primeira letra da primeira e última palavra
  const first = words[0][0];
  const last = words[words.length - 1][0];
  return (first + last).toUpperCase();
}
